import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Book from "@/pages/Book";
import BookSuccess from "@/pages/BookSuccess";
import Lookup from "@/pages/Lookup";
import Admin from "@/pages/Admin";

function App() {
    return (
        <div className="App min-h-screen bg-white text-[#121212]">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/book" element={<Book />} />
                    <Route path="/book/success" element={<BookSuccess />} />
                    <Route path="/lookup" element={<Lookup />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="top-right" richColors />
        </div>
    );
}

export default App;
